import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GrupoEmpresaService {

  constructor(
    private http: HttpClient) { }


  getAllGrupoEmpresa() {
    return this.http.get<any>(`${environment.apiUrl}/grupo-empresa`).pipe(tap(console.log));
  }
}
